/**
 * @file blog-header.js
 *
 */

(function ($, Drupal) {
  "use strict";

  Drupal.behaviors.blogheader = {
    attach: function (context, settings) {
      const blogHero = document.querySelector(".single-blog__hero");
      const stickyHero = $(".sticky-hero", context);
      const blogHeroHeight = $(".single-blog__hero", context).outerHeight();

      stickyHero.find("a").attr("tabindex", "-1");

      const waypoint = new Waypoint({
        element: blogHero,
        handler: function (direction) {
          stickyHero.toggleClass("sticky");

          const isSticky = stickyHero.hasClass("sticky");

          !isSticky
            ? stickyHero.find("a").attr("tabindex", "-1")
            : stickyHero.find("a").attr("tabindex", "0");
        },
        offset: function () {
          return -blogHeroHeight + 100;
        },
      });
    },
  };
})(jQuery, Drupal);
